import React, { ReactElement } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Outlet } from 'react-router-dom';

import { ModuleDeclaration } from '../ModuleDeclaration';

import EditTheme from './EditTheme/EditTheme';
import ThemeList from './ThemeList/ThemeList';


const ThemesContainer = (props: any): JSX.Element => {
  const element = withAuthenticationRequired(Outlet)(props);
  return element! as ReactElement;
};

const ThemeRouteProperties: ModuleDeclaration = {
  routeProps: {
    path: '/themes',
    element: <ThemesContainer />,
    children: [
      { index: true, element: <ThemeList /> },
      { path: '/themes/edit/:id', element: <EditTheme /> },
    ],
  },
  name: 'Themes',
  isHidden: false,
  containerCss: 'p-5 mb-5 border-bottom container-fluid',
  iconClassName: 'bi bi-megaphone',
};

export default ThemeRouteProperties;
